import React, { useMemo } from "react";
import { Route, Switch } from "react-router-dom";

import CloudOutlinedIcon from "@mui/icons-material/CloudOutlined";
import PollOutlinedIcon from "@mui/icons-material/PollOutlined";
import { IconProps, Stack } from "@mui/material";
import { HorizontalNavBar, RoleComponentGuard } from "components";
import { AccessDenied } from "components/Access-denied/AccessDenied";
import { Routes } from "constants/routes";
import { useNavigate } from "hooks";
import { useAccountSelector, usePickUserPermissions } from "store";
import { UserPermissionType } from "store/types";

import { RoleName } from "../../constants";
import { DataRooms } from "../Data-rooms/DataRooms";
import { Plaid } from "../Plaid/Plaid";

const iconsSx: IconProps["sx"] = {
  fontSize: "16px",
  mr: "6px"
};

export const CloudIntegrations: React.FC = () => {
  const navigate = useNavigate();
  const cloudIntegrations = usePickUserPermissions("cloud_integrations");
  const noAccessPermission = cloudIntegrations && cloudIntegrations === UserPermissionType.NO_ACCESS;
  const isViewerPermission = cloudIntegrations && cloudIntegrations === UserPermissionType.VIEWER;
  const isEditorPermission = cloudIntegrations && cloudIntegrations === UserPermissionType.EDITOR;
  const { is_freemium, upgraded_from_freemium } = useAccountSelector() || {};

  const hideChild = useMemo(() => {
    if (is_freemium) return false;
    if (upgraded_from_freemium) return false;
    return noAccessPermission || isViewerPermission || isEditorPermission;
  }, [noAccessPermission, isViewerPermission, isEditorPermission, is_freemium, upgraded_from_freemium]);

  return (
    <RoleComponentGuard
      availableRoles={[RoleName.Admin, RoleName.Analyst]}
      hideChild={hideChild}
      RenderInstead={<AccessDenied redirectClick={() => navigate({ route: "myDeals" })} title="Go to my deals" />}
    >
      <Stack sx={{ flexGrow: 1, overflow: "hidden" }}>
        <HorizontalNavBar
          tabs={[
            {
              value: "data-rooms",
              label: "Data Rooms",
              icon: <CloudOutlinedIcon sx={iconsSx} />,
              to: Routes.dataRooms,
              matchRouts: [Routes.dataRooms]
            },
            {
              value: "plaid",
              label: "Plaid",
              icon: <PollOutlinedIcon sx={iconsSx} />,
              to: Routes.plaid,
              matchRouts: [Routes.plaid]
            }
          ]}
          sx={{ marginBottom: "20px", minHeight: "25px", maxHeight: "25px" }}
        />
        <Switch>
          <Route exact path={Routes.dataRooms} component={DataRooms} />
          <Route exact path={Routes.plaid} component={Plaid} />
        </Switch>
      </Stack>
    </RoleComponentGuard>
  );
};
